/**
 * Settings → 申請管理: tabs — 各種コピー（コピー提出マスタ） / 記入書類
 */
import React, { useState } from 'react';
import VariousCopiesUpload from './variousCopiesUpload/VariousCopiesUpload';
import FormsToFillUpload from './formsToFillUpload/FormsToFillUpload';
import './applicationManagement.css';

type ApplicationSettingsTab = 'various-documents' | 'filling-documents';

const ApplicationManagement: React.FC = () => {
  const [activeTab, setActiveTab] = useState<ApplicationSettingsTab>('various-documents');

  return (
    <div className="app-mgmt-settings">
      <div className="app-mgmt-settings__tabs" role="tablist" aria-label="申請種別">
        <button
          type="button"
          role="tab"
          id="app-mgmt-tab-various"
          aria-selected={activeTab === 'various-documents'}
          aria-controls="app-mgmt-panel-various"
          className={`app-mgmt-settings__tab ${activeTab === 'various-documents' ? 'app-mgmt-settings__tab--active' : ''}`}
          onClick={() => setActiveTab('various-documents')}
        >
          アップロード書類
        </button>
        <button
          type="button"
          role="tab"
          id="app-mgmt-tab-filling"
          aria-selected={activeTab === 'filling-documents'}
          aria-controls="app-mgmt-panel-filling"
          className={`app-mgmt-settings__tab ${activeTab === 'filling-documents' ? 'app-mgmt-settings__tab--active' : ''}`}
          onClick={() => setActiveTab('filling-documents')}
        >
          記入書類
        </button>
      </div>

      {activeTab === 'various-documents' && (
        <div
          id="app-mgmt-panel-various"
          role="tabpanel"
          aria-labelledby="app-mgmt-tab-various"
          className="app-mgmt-settings__panel"
        >
          <VariousCopiesUpload />
        </div>
      )}

      {activeTab === 'filling-documents' && (
        <div
          id="app-mgmt-panel-filling"
          role="tabpanel"
          aria-labelledby="app-mgmt-tab-filling"
          className="app-mgmt-settings__panel"
        >
          <FormsToFillUpload />
        </div>
      )}
    </div>
  );
};

export default ApplicationManagement;
